import { NgModule, LOCALE_ID  } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import {registerLocaleData} from '@angular/common';

import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { TranslateModule } from '@ngx-translate/core';
//import 'hammerjs';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { CommonModule } from '@angular/common';
import { WINDOW_PROVIDERS } from './providers/window.providers';
import { MatInputCounterModule } from '@angular-material-extensions/input-counter';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

registerLocaleData(localePt);

const appRoutes: Routes = [
    
    {
        path        : '',
        loadChildren: () => import('./main/ui/ui.module').then(m => m.UIModule),
    }
];
    
@NgModule({
    declarations: [
        AppComponent,       
    ],
    imports     : [
        BrowserModule,
        CommonModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),

        TranslateModule.forRoot(),
        
        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        MatInputCounterModule,
        MatDialogModule
    ],
    providers: [WINDOW_PROVIDERS, {
        provide: LOCALE_ID, 
        useValue: "pt-BR"
      }],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
